import { BrowserRouter as Router } from 'react-router-dom'
import { LanguageProvider } from '@afsa/shared'
import { QueryProvider } from '@/lib/api/query-client'
import Header from '@/components/ui/Header/Header'
import ScrollToTop from '@/components/ScrollToTop'

import Footer from '@/components/sections/Footer'
import { Toaster } from 'sonner';
import AppRoutes from '@/routes/routes'


function App() {
  return (
    <QueryProvider>
      <LanguageProvider>
        <Router>
          <Toaster position="top-center"/>
          <ScrollToTop />
          <div className="min-h-screen flex gap-8 flex-col">
            <Header />

            <main className="flex-1 w-full">
              <AppRoutes />
            </main>

            <Footer />
          </div>
        </Router>
      </LanguageProvider>
    </QueryProvider>
  )
}

export default App
